import { styled } from "@material-ui/core";
import React, { createContext, memo, useCallback, useEffect, useRef, useState } from "react";
import { animated, config, useSpring } from "react-spring";
import { CodeInputSlot } from "./CodeInputSlot";
const Container = styled("div")(() => ({
    position: "relative",
    display: "grid",
    "grid-auto-flow": "column",
    "grid-gap": "8px",
    margin: "-4px",
    padding: "4px"
}));
const Marker = styled("div")(({ theme }) => ({
    width: "85%",
    height: "4px",
    margin: "0 auto",
    borderRadius: "4px",
    background: theme.palette.primary.main
}));
const SlotMarker = (props) => {
    const { items, index, visible } = props;
    const width = index === null ? 100 : 100 / (items || 1);
    const left = width * index;
    const [style, setStyle] = useSpring(() => ({
        config: config.stiff,
        from: {
            left: "0%",
            position: "absolute",
            width: `${width}%`,
            bottom: visible ? -2 : -4,
            scale: visible ? 1 : 0,
            opacity: visible ? 1 : 0
        }
    }));
    useEffect(() => {
        setStyle({
            bottom: visible ? -2 : -4,
            scale: visible ? 1 : 0,
            opacity: visible ? 1 : 0
        });
    }, [setStyle, visible]);
    useEffect(() => {
        setStyle({
            left: `${left}%`
        });
    }, [left, setStyle, visible]);
    return (React.createElement(animated.div, { style: style },
        React.createElement(Marker, null)));
};
export const CodeInputContext = createContext(null);
export const CodeInput = memo((props) => {
    const container = useRef();
    const [focusIndex, setFocusIndex] = useState(0);
    const [focusedSlots, setFocusedSlots] = useState(props.values.map(() => false));
    const focusNext = useCallback(() => {
        setFocusIndex((index) => index + 1);
    }, []);
    const focusPrevious = useCallback(() => {
        setFocusIndex((index) => index - 1);
    }, []);
    const focus = useCallback((index) => {
        setFocusIndex(index);
    }, []);
    const setFocused = (index, focused) => {
        setFocusedSlots((current) => {
            return props.values.map((_, slot) => {
                if (slot === index) {
                    return focused;
                }
                return current[slot] || false;
            });
        });
    };
    const focused = focusedSlots.some((active) => active === true);
    return (React.createElement(CodeInputContext.Provider, { value: {
            values: props.values,
            autofocus: props.autofocus,
            setFocused,
            focusIndex,
            focus,
            focusNext,
            focusPrevious
        } },
        React.createElement(Container, { ref: container },
            props.values.map((_, index) => (React.createElement(CodeInputSlot, { key: index, index: index, onChange: props.onChange, alphanumeric: props.alphanumeric }))),
            React.createElement(SlotMarker, { items: props.values.length, index: focusIndex, visible: focused }))));
});
//# sourceMappingURL=CodeInput.js.map